import { useEffect, useState } from "react";
import SlidingPanel from "./SlidingPanel";
import Logout from "@assets/logout/logout.svg";
import { useMediaQuery } from "react-responsive";

interface LogoutSlidingPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onClickConfirm: () => void;
  sliderHeading?: string;
  type: string;
}

const LogoutSlidingPanel = ({
  isOpen,
  onClose,
  onClickConfirm,
  sliderHeading = "",
  type,
}: LogoutSlidingPanelProps) => {
  const [countdown, setCountdown] = useState<number>(0);
  const isMobile = useMediaQuery({ query: "(max-width: 680px)" });

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={sliderHeading}
      onClose={() => {
        onClose();
      }}
      isMobile={isMobile}
      isSlider={isMobile ? true : false}
    >
      <div className="flex flex-col px-[16px] pb-[16px] pt-[8px]">
        <div className="flex flex-col">
          <div className="flex flex-col justify-center items-center  space-y-[16px]">
            <div className="text-text-base text-[14px] font-normal">
              Are you sure you want to logout?
            </div>
            <button
              className="flex items-center justify-center border-solid border-[1px] border-border-button rounded-md w-full py-[6px] mb-[12px] cursor-pointer"
              onClick={() => {
                onClickConfirm();
              }}
            >
              <img src={Logout} alt="" className="pr-[8px]" />
              <span className="text-[14px] font-semibold">LOGOUT</span>
            </button>

            <button
              className="text-[14px] font-semibold cursor-pointer"
              onClick={() => {
                onClose();
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </SlidingPanel>
  );
};

export default LogoutSlidingPanel;
